import { PALETTE, SIZES, MQ_TABLET} from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

const borderColor = '#8d97aa';
const backgroundColor = '#0d1a35';

export default MediaQueryStyleSheet.create({

  paymentBtnBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 20
  },
    textHoldScreen: {
    fontSize:16
  },
  paymentBtnTerminate: {
    display: 'flex',
    justifyContent: 'center',
    margin: 20
  },
    textHoldScreen: {
    fontSize:16
  },
  paymentTimer: {
    borderWidth: 2,
    borderColor: borderColor,
    borderRadius: 4,
    paddingHorizontal: 5,
    paddingVertical: 10,
    marginLeft: 10,
    backgroundColor: backgroundColor
  },
  pymtMobCnfrmStps:{
    marginTop:15
  },
  paymentNewRMrgn:{
    marginRight:10
  },
  cancelContainer:{
    padding: '12px 10px 12px 20px'
  }
});

export const selectedSVGStyles = {
  color: PALETTE.primaryText,
  radius: 4,
};